import 'katex/dist/katex.min.css';
import React, { memo, useMemo } from 'react';
import { getMixedMathSegments, katexToHtml } from '../../utils/mathMixedText';

export type MathMixedTextProps = {
  text: string;
  className?: string;
  /** pre-line: giữ xuống dòng như mô tả bài; pre-wrap: mặc định */
  whitespaceMode?: 'wrap' | 'line';
};

/**
 * Hiển thị văn bản kèm công thức LaTeX (KaTeX). Delimiter: $...$, $$...$$, \\(...\\), \\[...\\].
 * Chuỗi không có delimiter vẫn quét legacy (\\frac, \\ce, sin x=..., v.v.) — đồng bộ backend PDF/DOCX.
 */
export const MathMixedText = memo(function MathMixedText({
  text,
  className = '',
  whitespaceMode = 'wrap',
}: MathMixedTextProps) {
  const raw = text ?? '';
  const segments = useMemo(() => getMixedMathSegments(raw), [raw]);
  const textWs = whitespaceMode === 'line' ? 'whitespace-pre-line' : 'whitespace-pre-wrap';

  if (!segments.length) {
    return <span className={`${textWs} ${className}`} />;
  }

  return (
    <span className={`math-mixed-root inline-block max-w-full align-top ${className}`}>
      {segments.map((seg, idx) => {
        if (seg.type === 'text') {
          return (
            <span key={idx} className={textWs}>
              {seg.content}
            </span>
          );
        }
        if (seg.type === 'display') {
          return (
            <span
              key={idx}
              className="block w-full my-2 overflow-x-auto text-center"
              dangerouslySetInnerHTML={{ __html: katexToHtml(seg.content, true) }}
            />
          );
        }
        return (
          <span
            key={idx}
            className="inline-block align-middle mx-0.5 max-w-full overflow-x-auto"
            dangerouslySetInnerHTML={{ __html: katexToHtml(seg.content, false) }}
          />
        );
      })}
    </span>
  );
});

export default MathMixedText;
